<div class="filters">
    <mat-form-field class="assignee-filter">
        <mat-label>Assignee</mat-label>
        <mat-select multiple [(value)]="this.selectedAssignees">
            <mat-option *ngFor="let assignee of this.assignees" [value]="assignee">{{assignee}}</mat-option>
        </mat-select>
    </mat-form-field>
</div>

<mat-selection-list *ngIf="this.model"
                    #list
                    [multiple]="false"
                    (click)="this.onSelectionChange()"
                    
                    >
    <mat-list-option disableRipple
                     *ngFor="let task of this.model.tasks"
                     [selected]="task.id == this.selectedTaskId"
                     [value]="task" style="padding-top: 10px;padding-bottom: 10px;">
        <app-task-list-item #listItem
                            [model]="task"
                            [isDisabled]="this.isTaskDisabled(task)"
                            [lineId]="this.model.lineId"
                            style="height: auto !important;">
        </app-task-list-item>
    </mat-list-option>
</mat-selection-list>